module.exports = __webpack_public_path__ + "img/bariol-bold.52852eb6.svg";